import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0a919bfc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0a919bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a919bfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a919bfc')) {
      api.createRecord('0a919bfc', component.options)
    } else {
      api.reload('0a919bfc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0a919bfc&scoped=true&", function () {
      api.rerender('0a919bfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vLij3Hf192Q7/JS/comp/PopupBox.vue"
export default component.exports